// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","spinner":"Spinner_spinner__LTzVq","Center":"Spinner_Center__aNjzD"};